<template>
  <div
    class="fixed right-12 bottom-28 left-auto top-auto bg-666 move_video z-50"
    :style="{
      width: '100%',
      height:'100%',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    }"
    key="move_cont"
    v-if="isFull"
  >
    <!-- <i
      class="el-icon-full-screen text-medium-x text-white absolute top-3 right-11 z-10 cursor-pointer"
      @click="fullScreenHandle"
    ></i> -->
    <i
      class="el-icon-close text-medium-x text-white absolute top-3 right-3 z-10 cursor-pointer"
      @click="closeHandle"
    ></i>
    <video-player
      ref="video"
      :options="options"
    ></video-player>
  </div>
  <div
    class="fixed right-12 bottom-28 left-auto top-auto bg-666 move_video z-50"
    :style="{
      width: options.width,
      height: options.height,
      left: null,
      top: null,
      right: null,
      bottom: null
    }"
    key="static_cont"
    v-move
    v-else
  >
    <!-- <i
      class="el-icon-full-screen text-medium-x text-white absolute top-3 right-11 z-10 cursor-pointer"
      @click="fullScreenHandle"
    ></i> -->
    <i
      class="el-icon-close text-medium-x text-white absolute top-3 right-3 z-10 cursor-pointer"
      @click="closeHandle"
    ></i>
    <video-player
      ref="video"
      :options="options"
    ></video-player>
  </div>
</template>

<script>
import { videoPlayer as VideoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  name: 'MoveVideo',
  components: {
    VideoPlayer
  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      options: {
        playbackRates: [0.25, 0.5, 1.0, 1.5, 2.0, 4.0, 8.0],
        sources: [
          {
            type: "video/mp4"||"video/webm"||"video/ogg"||"video/3gp",
            src: this.src
          }
        ],
        width: '320px',
        height: '180px'
      },
      isFull: !!document.fullscreenElement,
    }
  },
  watch: {
    src(url) {
      this.setURL(url);
    }
  },
  methods: {
    setURL(url) {
      if (this.$refs.video) {
        this.$refs.video.player.src(url);
      } else {
        this.options.sources.src = url;
      }
    },
    fullScreenHandle() {
      const doc = document.documentElement;
      const fullScreen = doc.requestFullscreen || doc.msRequestFullscreen || doc.mozRequestFullScreen || doc.webkitRequestFullScreen;
      const exitScreen = document.exitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen || document.webkitCancelFullScreen;
      if (document.fullscreenElement) {
        this.isFull = false;
        exitScreen.call(document);
      } else {
        this.isFull = true;
        fullScreen.call(doc);
      }
    },
    closeHandle() {
      const doc = document.documentElement;
      const fullScreen = doc.requestFullscreen || doc.msRequestFullscreen || doc.mozRequestFullScreen || doc.webkitRequestFullScreen;
      const exitScreen = document.exitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen || document.webkitCancelFullScreen;
      if (document.fullscreenElement) {
        this.isFull = false;
        exitScreen.call(document);
      }
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.move_video {
  ::v-deep .video-player {
    height: 100%;
    .video-js {
      width: 100%;
      height: 100%;
    }
  }
}
</style>